
/**
 * @file Signup error types
 * @author Denny K. Schuldt
 * @copyright Copyright 2017, Datilmedia S.A.
 */

export const USERNAME_NO_WHITE_SPACE_ERR = "El nombre de usuario no puede contener espacios"
export const USERNAME_NO_ACCENT_MARK_ERR = "El nombre de usuario no puede contener tildes"
export const USERNAME_NOT_AVAILABLE_ERR = "El nombre de usuario ya está en uso"
export const USERNAME_IS_A_EMAIL_ERR = "Debes ingresar un nombre de usuario que no sea un correo"
export const USERNAME_EMPTY_ERR = "Debes ingresar un nombre de usuario"

export const EMAIL_NOT_VALID_ERR = "Debes ingresar un correo válido"
export const EMAIL_NOT_AVAILABLE_ERR = "El correo ya está en uso"
export const EMAIL_EMPTY_ERR = "Debes ingresar un correo"

export const PASSWORD_EMPTY_ERR = "Debes ingresar una contraseña"
export const PASSWORD_NOT_VALID_LENGTH_ERR = "Tu contraseña debe tener al menos 8 caracteres"
export const PASSWORD_NOT_VALID_PATTERN_ERR = "Tu contraseña no debe tener espacios en blanco al final"
export const PASSWORD_NOT_VALID_NOT_UPPER = "Tu contraseña debe contener al menos una mayúscula"
export const PASSWORD_NOT_VALID_NOT_NUMBER = "Tu contraseña deber contener al menos un número"
export const PASSWORD_NOT_VALID = "Tu contraseña no es válida"

export const SERVICE_NOT_AVAILABLE_ERROR = "No pudimos registrarte en este momento. Por favor inténtalo luego de unos minutos."
export const USERNAME_ALREADY_EXISTS_ERROR = "Ya existe una cuenta con el usuario"
export const EMAIL_ALREADY_EXISTS_ERROR = "Ya existe una cuenta con el correo"
